import React from 'react';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import config from 'config';
import styles from './DonateButton.scss';
import {
  ExperimentKeys,
  experiments as experimentConstants,
} from 'src/constants/experiments';
import { encodeBase64 } from 'src/helpers/base64';
import { Trans } from 'react-i18next';
import { Experiment, Variation } from '@justgiving/experiments';

type Props = {
  isActive: boolean;
  name: string;
  pageSection: string;
  donate: (options: { pageSection: string }) => void;
  experiments?: ExperimentKeys[];
  successType?: string;
};

function DonateButton({
  isActive,
  name,
  pageSection,
  donate,
  // Pass all the experiments by default
  experiments = Object.values(experimentConstants),
  successType = 'StaticDonateButtonClick',
}: Props) {
  const buttonClass = classNames('jg-btn', {
    'is-disabled': !isActive,
  });

  const buildQueryString = () => {
    const urlParams = new URLSearchParams();

    if (pageSection) {
      urlParams.append('pageSection', pageSection);
    }

    const trimmedSuccessType = successType.trim();
    const trimmedExperiments = experiments
      .map(e => e.trim())
      .filter(e => e !== '');

    if (
      trimmedExperiments &&
      trimmedExperiments.length > 0 &&
      trimmedSuccessType
    ) {
      urlParams.append(
        'experiments',
        encodeBase64(trimmedExperiments.join(','))
      );
      urlParams.append('successType', encodeBase64(trimmedSuccessType));
    }

    return urlParams.toString() ? `?${urlParams.toString()}` : '';
  };

  return (
    <a
      data-marker="donate-button"
      onClick={() => donate({ pageSection })}
      href={`${
        config.CROWDFUNDING_BASE_URI
      }/${name}/donate${buildQueryString()}`}
      className={buttonClass}
      styleName="fixed-donate-button"
    >
      {/*// B2C_047 - Donate button text*/}
      {/*// Can be removed when experiment has ended*/}
      <Experiment slug={experimentConstants.b2c_047_donate_button_text}>
        <Variation name="A">
          <Trans i18nKey="Common.Donate">Donate Now</Trans>
        </Variation>
        <Variation name="B">
          <Trans i18nKey="Common.Donate.B">Donate</Trans>
        </Variation>
        <Variation name="C">
          <Trans i18nKey="Common.Donate.C">Donate Today</Trans>
        </Variation>
        <Variation name="D">
          <Trans i18nKey="Common.Donate.D">Give Now</Trans>
        </Variation>
      </Experiment>
    </a>
  );
}

export default CSSModules(DonateButton, styles);



// WEBPACK FOOTER //
// ./src/components/Page/DonateButton.tsx